import React from "react";
import "../styles/Consumerbanner.css";

import img1 from "../consume-banner/assets/liver/liverintake2.png";
import img2 from "../consume-banner/assets/liver/liverintake1.png";

const LiverConsumeBanner = () => {
  const steps = [
    {
      img: img1,
      title: "Step 1",
      text: "Take 1-2 tablets with lukewarm water",
    },
    {
      img: img2,
      title: "Step 2",
      text: "Consume twice daily after meals for best results",
    },
  ];

  return (
    <section className="consume-banner">
      <h2 className="consume-heading">
        सेवन करने का तरीका (How To Consume)
      </h2>

      <div className="consume-images">
        {steps.map((step, index) => (
          <div className="consume-card" key={index}>
            <img src={step.img} alt={step.title} />
            <h4>{step.title}</h4>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LiverConsumeBanner;
